"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _order = require("@/api/order");
var _zeroorder = require("@/api/zeroorder");
var _device_salesorder = require("@/api/device_salesorder");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultOrder = {
  zero_check_status: '',
  remark: ''
};
var _default = exports.default = {
  data: function data() {
    return {
      dialogTransformLoading: false,
      transformData: {
        results: []
      },
      listLoading: true,
      tableData: [],
      order: defaultOrder,
      order1: {},
      dialogVisible: false,
      approvalDialog: false,
      viewDialog: false,
      shipmentDialog: false,
      dialogType: 'new',
      number: '',
      rule1: {
        zero_check_status: [{
          required: true,
          message: '请选择确认状态',
          trigger: 'change'
        }],
        remark: [{
          max: 200,
          message: '输入长度不能超过200位',
          trigger: 'blur'
        }]
      },
      listQuery: {
        page: 1,
        page_size: 10
      },
      typeOptions: [{
        value: 1,
        label: '通过'
      }, {
        value: 2,
        label: '拒绝'
      }],
      orgList: [],
      columnList: ['商品名称', '商品数量']
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.listQuery.page_size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.listQuery.page = val;
      this.getList();
    },
    checkPermission: _permission.default,
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _zeroorder.getZeroOrderList)(this.listQuery).then(function (response) {
        if (response.data) {
          // console.log(response.data)
          _this.tableData = response.data;
        }
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleConfirm: function handleConfirm(scope) {
      var _this2 = this;
      this.order1 = Object.assign({}, scope.row); // copy obj
      this.order = Object.assign({}, defaultOrder);
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs['Form'].clearValidate();
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(form) {
        var _this3 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  if (_this3.order.zero_check_status === 1) {
                    (0, _zeroorder.updateZeroOrder)(_this3.order1.id, _this3.order).then(function (response) {
                      _this3.dialogVisible = false;
                      _this3.getList();
                      _this3.$message({
                        message: '确认通过',
                        type: 'success'
                      });
                    });
                  } else if (_this3.order.zero_check_status === 2) {
                    (0, _zeroorder.updateZeroOrder)(_this3.order1.id, _this3.order).then(function (response) {
                      _this3.dialogVisible = false;
                      _this3.getList();
                      _this3.$message({
                        message: '确认拒绝',
                        type: 'warning'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};